import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { Loading } from 'element-ui';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000 // request timeout
})

let loadingInstance;

// 提示
const handleMessage = (msg, type) => {
  Message({
    message: msg || 'Error',
    type,
    duration: 3000
  });
};


service.interceptors.request.use(
  config => {
    config.headers['tokenu'] = localStorage.getItem('tokenu') //用户token
    config.headers['tokena'] = localStorage.getItem('tokena') // 管理员token
    config.headers['domain'] = process.env.VUE_APP_BASE_API // 域名
    loadingInstance = Loading.service(
      {
        // lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      }
    );
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    loadingInstance.close()
    const { code, msg, showToast } = response.data;
    // 状态异常
    if (code != 200) {
      handleMessage(msg, 'error');
    }
    //后端接口需要显示提示
    if (showToast) {
      handleMessage(msg, 'success');
    }
    // 未登陆
    if (code == 201) {
      router.push('/login')
    }
    return response.data;
  },
  error => {
    loadingInstance.close();
    const { response } = error;
    if (response) {
      const { code, msg } = response.data;
      if (code !== 200) {
        handleMessage(msg, 'error');
      }
      return response.data;
    } else {
      console.error('Request failed:', error);
      handleMessage(error.message, 'error');
      return Promise.reject(error);
    }
  },
);

export default service
